import {RepromaterialOverviewReport} from "../models/Report";
import {RepromaterialOverviewReportTemplateData} from "./RepromaterialOverviewReportTemplateData";
import {RepromaterialOverviewReportImportTemplate} from "./RepromaterialOverviewReportImportTemplate";
import {cloneDeep} from "lodash";

export const getRepromaterialOverviewReportTemplate = (
    dataRepromaterial: RepromaterialOverviewReport[],
    selectedWarehouse: string,
    selectedDay: Date
    
    ) => {
    return RepromaterialOverviewReportImportTemplate(
        prepareData(
            dataRepromaterial,
            selectedWarehouse,
            selectedDay
        )
    );
};

const prepareData = (
    documentDataRepromaterial: RepromaterialOverviewReport[],
    selectedWarehouse: string,
    selectedDay: Date
    ) => {
    const templateData: RepromaterialOverviewReportTemplateData = {
        reportByRepromaterial: cloneDeep(documentDataRepromaterial),
        warehouseName: selectedWarehouse,
        selectedDay: selectedDay
    };

    return templateData;
};